import React from 'react';

export default function Header({ user, userSubscription, isAuth, onTariffs, onLogout, onLogin, onMapClick }) {
    return (
        <header className="relative overflow-hidden min-h-[440px] sm:min-h-[380px]">
            {/* Фото экскаватора — фиксированный фон */}
            <div 
                className="absolute inset-0"
                style={{ 
                    backgroundImage: 'url(/hero-bg.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'right center',
                    backgroundRepeat: 'no-repeat'
                }}
            />
            
            {/* Затемнение слева (для текста) */}
            <div 
                className="absolute inset-0"
                style={{
                    background: 'linear-gradient(90deg, rgba(10,17,24,0.95) 0%, rgba(10,17,24,0.85) 35%, rgba(10,17,24,0.3) 70%, rgba(10,17,24,0.2) 100%)'
                }}
            />
            
            {/* Контент */}
            <div className="relative max-w-7xl mx-auto px-4 h-full flex flex-col">
                {/* Верхняя панель */}
                <div className="flex flex-wrap justify-between items-center gap-y-2 py-4">
                    <a href="/" className="text-base md:text-xl font-black text-white no-underline uppercase tracking-tight drop-shadow-lg">
                        АРЕНДА СПЕЦТЕХНИКИ
                    </a>
                    
                    <div className="flex items-center gap-2 md:gap-3">
                        {isAuth ? (
                            <>
                                <span className="text-sm text-white/90 hidden md:inline font-medium drop-shadow">{user?.name || user?.email}</span>
                                {userSubscription?.is_active ? (
                                    <div className="flex items-center gap-2 bg-black/50 backdrop-blur-md border border-gold/60 rounded-full px-3 py-1.5 max-w-full">
                                        <span className="text-[10px] sm:text-xs text-gold font-bold uppercase whitespace-nowrap">📦 <span className="hidden sm:inline">{userSubscription.tariff?.name}</span><span className="sm:hidden">{(userSubscription.tariff?.name || '').split(' ')[0]}</span></span>
                                        <button onClick={onTariffs} className="text-[10px] sm:text-xs text-gold hover:text-gold-hover bg-transparent border-none cursor-pointer font-bold whitespace-nowrap">УЛУЧШИТЬ</button>
                                    </div>
                                ) : (
                                    <button onClick={onTariffs} className="text-[10px] sm:text-xs bg-gold hover:bg-gold-hover text-industrial-bg font-black rounded-full px-2.5 sm:px-4 py-1.5 sm:py-2 transition uppercase whitespace-nowrap shadow-gold">
                                        ⭐ СТАТЬ ИСПОЛНИТЕЛЕМ
                                    </button>
                                )}
                                <button onClick={onLogout} className="text-sm text-white/90 hover:text-white bg-transparent border-none cursor-pointer font-medium whitespace-nowrap drop-shadow">Выйти</button>
                            </>
                        ) : (
                            <button onClick={onLogin} className="bg-gold hover:bg-gold-hover text-industrial-bg font-black px-3 sm:px-5 py-2 sm:py-2.5 rounded-xl transition text-xs sm:text-sm shadow-gold uppercase whitespace-nowrap">
                                ВОЙТИ
                            </button>
                        )}
                    </div>
                </div>

                {/* Hero — центр */}
                <div className="flex-1 flex flex-col justify-center pb-10 max-w-2xl">
                    <div className="inline-block bg-gold text-industrial-bg rounded-lg px-4 py-1.5 mb-4 shadow-gold w-fit">
                        <span className="text-xs font-black uppercase tracking-widest">🏗️ ОНЛАЙН-БРОНИРОВАНИЕ 24/7</span>
                    </div>
                    
                    <h1 
                        className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-3 tracking-tight leading-tight uppercase"
                        style={{ textShadow: '0 4px 24px rgba(0,0,0,0.95), 0 2px 8px rgba(0,0,0,0.8)' }}
                    >
                        АРЕНДА СПЕЦТЕХНИКИ<br/>
                        <span className="text-gold">В РОССИИ ЗА 2 МИНУТЫ</span>
                    </h1>
                    
                    <p 
                        className="text-base md:text-lg text-white mb-6 max-w-xl font-medium"
                        style={{ textShadow: '0 2px 12px rgba(0,0,0,0.9)' }}
                    >
                        Экскаваторы, краны, погрузчики, самосвалы. Безопасная сделка с гарантией.
                    </p>
                    
                    <div className="flex gap-3 flex-wrap">
                        <button 
                            onClick={onMapClick} 
                            className="bg-gold hover:bg-gold-hover text-industrial-bg font-black px-7 py-3.5 rounded-xl transition text-sm shadow-gold-lg uppercase"
                        >
                            🔍 НАЙТИ ТЕХНИКУ
                        </button>
                        <button 
                            onClick={onTariffs} 
                            className="bg-black/60 backdrop-blur-md border-2 border-gold/60 text-white font-black px-7 py-3.5 rounded-xl hover:bg-black/70 hover:border-gold transition text-sm uppercase"
                        >
                            💰 СДАТЬ ТЕХНИКУ
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
}
